
import { defineComponent } from 'vue'

import ActiveUserMixin, { DashboardContext } from '~/mixins/activeUserMixin'
import AuthMixin from '~/mixins/authMixin'
import ContextMixin from '~/mixins/contextMixin'
import { TeamPerms } from '~/types/permTypes'
import { getDefaultAvatar } from '~/utils/ui'

const FREE_PLAN_SLUG = 'free'

export default defineComponent({
  name: 'DashboardHeader',
  mixins: [ActiveUserMixin, ContextMixin, AuthMixin],
  methods: {
    getDefaultAvatar
  },
  computed: {
    planName(): string {
      return (this.activeDashboardContext as DashboardContext).subscribed_plan_info?.name
    },
    hasPaidPlan(): boolean {
      return (
        (this.activeDashboardContext as DashboardContext).subscribed_plan_info?.slug !==
        FREE_PLAN_SLUG
      )
    },
    canVisitBillingPage(): boolean {
      if (this.teamPerms.permission && this.activeOwner === this.$route.params.owner) {
        return this.$gateKeeper.team(
          [
            TeamPerms.CHANGE_PLAN,
            TeamPerms.UPDATE_SEATS,
            TeamPerms.DELETE_TEAM_ACCOUNT,
            TeamPerms.UPDATE_BILLING_DETAILS
          ],
          this.teamPerms.permission
        )
      }
      return false
    },
    repoVCSIcon(): string {
      const provider = this.activeDashboardContext.vcs_provider
      return this.$providerMetaMap[provider]?.icon ?? ''
    }
  }
})
